exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(max-width:1100px)\r\n{\r\n.left-nav-custom{margin-top: 22px;}\r\n}\r\n\r\n.disabledClass{\r\n  background: #5d5d5d;\r\n  color: #9F9F9F !important;\r\n  cursor: not-allowed;\r\n}\r\n.disabledClass:hover {\r\n  background: #5d5d5d;\r\n}\r\n.disabledClass:active {\r\n  background: #5d5d5d;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/theme/sidebar/sidebar.component.css
// module id = ../../../../../src/app/theme/sidebar/sidebar.component.css
// module chunks = theme.module